import { useLanguage } from "@/i18n/LanguageContext";

const descKeys = [
  "serviceAreas.t3desc1",
  "serviceAreas.t3desc2",
  "serviceAreas.t3desc3",
  "serviceAreas.t3desc4",
  "serviceAreas.t3desc5",
  "serviceAreas.t3desc6",
  "serviceAreas.t3desc7",
  "serviceAreas.t3desc8",
];

const tier3Areas = [
  { name: "Sunny Isles Beach", zips: ["33160"], descIdx: 0 },
  { name: "Hialeah", zips: ["33010", "33012", "33014"], descIdx: 1 },
  { name: "Surfside", zips: ["33154"], descIdx: 2 },
  { name: "Bal Harbour", zips: ["33154"], descIdx: 3 },
  { name: "Cutler Bay", zips: ["33157", "33189"], descIdx: 4 },
  { name: "Palmetto Bay", zips: ["33157", "33158"], descIdx: 5 },
  { name: "Homestead", zips: ["33030", "33032", "33033"], descIdx: 6 },
  { name: "Miami Shores", zips: ["33138"], descIdx: 7 },
];

export default function Tier3Section() {
  const { t } = useLanguage();
  return (
    <section className="bg-white py-16 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block bg-[#fbbf24] text-secondary text-xs font-bold px-4 py-1.5 rounded-full mb-4">
            {t("serviceAreas.tier3Badge")}
          </span>
          <h2 className="text-2xl md:text-3xl font-black text-secondary mb-3">
            {t("serviceAreas.tier3H2")}
          </h2>
          <p className="text-base text-[#374151] max-w-2xl mx-auto">
            {t("serviceAreas.tier3Sub")}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {tier3Areas.map((area) => (
            <div
              key={area.name}
              className="bg-[#fefce8] rounded-xl border-2 border-[#fbbf24] p-5"
            >
              <h3 className="text-lg font-bold text-secondary mb-2">
                {area.name}
              </h3>
              <p className="text-xs text-[#374151] mb-3">
                {t("serviceAreas.cardZipLabel")}{area.zips.length > 1 ? t("serviceAreas.cardZipPlural") : ""}: {area.zips.join(", ")}
              </p>
              <span className="inline-block bg-[#fbbf24] text-secondary text-xs font-bold px-3 py-1 rounded-full mb-3">
                {t("serviceAreas.cardBadgeEmergency")}
              </span>
              <p className="text-sm text-[#374151] leading-relaxed">
                {t(descKeys[area.descIdx])}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}